import { DataModel } from "common/models/utility-models/base-model";

export class FeedbackPreviewModel extends DataModel {}
